import PropTypes from 'prop-types'
import React from 'react'
import DetailRow from '../../../../../components/DetailRow'
import JsonPrettyView from '../../policy_feature/JsonPrettyView'
import { INPUT_OPTIONS_MAP } from '../../policy_feature/inputs'

const propTypes = {
  /**
   * The template name
   */
  templateName: PropTypes.string,
  /**
   * If true, hide template name
   */
  hideName: PropTypes.bool,
  /**
   * The template description
   */
  templateDescription: PropTypes.string,
  /**
   * Array with the inputs selected
   */
  promptedInputs: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
   * The raw policy object
   */
  rawPolicy: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Object mapping the ids of possible values in the policy to a readable string
   */
  globalFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Name of the policy this template is based on
   */
  clonedPolicyName: PropTypes.string,
  /**
   * If true, shows the cloned policy field
   */
  showClonedPolicyField: PropTypes.bool,
  /**
   * If true, hides details header (title) and show toggle in line with content
   */
  headlessDetails: PropTypes.bool,
}

const getFormattedInputList = (promptedInputs, options = {}) =>
  promptedInputs
    ?.filter((input) => !input.autoResolved)
    ?.filter((input) => (options.required ? input.required : !input.required))
    ?.map((input) => INPUT_OPTIONS_MAP[input.name])
    ?.join(', ')

// A group field resolved via an attached requirement isn't manually prompted at deploy at all
// (unlike Required/Optional, which are both still prompted), so it gets its own list rather than
// defaulting into "Optional" just because it has no required/optional value.
const getFormattedAutoResolvedInputList = (promptedInputs) =>
  promptedInputs
    ?.filter((input) => input.autoResolved)
    ?.map((input) => INPUT_OPTIONS_MAP[input.name])
    ?.join(', ')

function ReviewTemplatePanel(props) {
  const {
    templateName = '',
    hideName = false,
    templateDescription = '',
    promptedInputs = [],
    rawPolicy = {},
    globalFormOptionsMap = {},
    clonedPolicyName = '',
    showClonedPolicyField = false,
    headlessDetails = false,
  } = props ?? {}

  return (
    <>
      {!hideName && <DetailRow label="POLICY_TEMPLATES.TEMPLATE_NAME" value={templateName} />}

      <DetailRow label="POLICY_TEMPLATES.DESCRIPTION" value={templateDescription} />

      <DetailRow
        label="POLICY_TEMPLATES.REQUIRE_INPUTS"
        value={getFormattedInputList(promptedInputs, { required: true })}
      />

      <DetailRow
        label="POLICY_TEMPLATES.ALLOWED_INPUTS"
        value={getFormattedInputList(promptedInputs, { required: false })}
      />

      <DetailRow
        label="POLICY_TEMPLATES.AUTO_RESOLVED_INPUTS"
        value={getFormattedAutoResolvedInputList(promptedInputs)}
      />

      {showClonedPolicyField && <DetailRow label="POLICY_TEMPLATES.CLONED_POLICY" value={clonedPolicyName} />}

      <hr className="mb-4" />
      {rawPolicy && (
        <JsonPrettyView rawPolicy={rawPolicy} policyFormOptionsMap={globalFormOptionsMap} headless={headlessDetails} />
      )}
    </>
  )
}

ReviewTemplatePanel.propTypes = propTypes

export default ReviewTemplatePanel
